/*
      ___           ___
     /\  \         /\  \
    /::\  \       /::\  \
   /:/\:\  \     /:/\ \  \
  /::\ \:\  \   _\:\ \ \  \
 /:/\:\ \:\__\ /\ \:\ \ \__\
 \/_|::\/:/  / \:\ \:\ \/__/
    |:|::/  /   \:\ \:\__\
    |:|\/__/     \:\/:/  /
    |:|  |        \::/  /
     \|__|         \/__/

    Developed by Ralph Shippam - 2019.
*/

import {RSDialog} from './rsdialog';
import DialogHandles = RSDialog.DialogHandles;
import {EventEmitter} from '@angular/core';

export class RSDialogComponentModel {
    // These are provided by the RSDialog

    // Dialog Values - This is as injected by the user. Can be anything
    private _dialogValues: any;
    public get dialogValues() {
        return this._dialogValues || {};
    }
    public set dialogValues(values: any) {
        this._dialogValues = values;
        this.dialogValuesUpdated.emit(this._dialogValues);
    }
    public dialogValuesUpdated: EventEmitter<any> = new EventEmitter<any>();

    // Dialog Handles - As injected by up to control the dialog
    public _dialogHandles: DialogHandles;
    public get dialogHandles() {
        return this._dialogHandles || { close: () => {} } as DialogHandles;
    }
    public set dialogHandles(values: any) {
        this._dialogHandles = values;
        this.dialogHandlesUpdated.emit(this._dialogHandles);
    }
    public dialogHandlesUpdated: EventEmitter<DialogHandles> = new EventEmitter<DialogHandles>();
}
